import ResourceAllocationOverview from './ResourceAllocationOverview';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';

export default withErrorBoundary(
  ResourceAllocationOverview,
  'Resource Allocation Overview'
);
